import { Entity, parseEntityRef } from '@backstage/catalog-model';

/**
 * Extracts related entity references from a given entity based on optional type and kind filters.
 *
 * @param entity - The entity for which related references are to be fetched.
 * @param relationFilter - An object containing optional type and kind filters to narrow down the relations.
 * @returns An object containing the filtered relations.
 * */
export function extractRelatedEntityRefs(
  entity: Entity,
  relationFilter: { type?: string; kind?: string },
) {
  const filterByTypeLower = relationFilter?.type?.toLocaleLowerCase('en-US');
  const filterByKindLower = relationFilter?.kind?.toLocaleLowerCase('en-US');

  const relations = entity.relations?.filter(
    r =>
      (!filterByTypeLower ||
        r.type.toLocaleLowerCase('en-US') === filterByTypeLower) &&
      (!filterByKindLower ||
        parseEntityRef(r.targetRef).kind === filterByKindLower),
  );

  return {
    relations: relations ?? [],
  };
}
